<script>
	/**
	 * 그림 칸 하나 — **썸네일 + 이름표(아래) + 권장 크기 + 비우기(✕)**. [레시피] 탭 공용.
	 *
	 * ⚠️⚠️ 예전엔 56px 썸네일 **안에** 10px 글자로 '배경'·'타이틀'을 적었다 — 그림을 넣으면 이름이
	 *    사라지고, 칸이 무엇인지 알 수 없어 저작자가 '타이틀을 넣을 데가 없다'고 느꼈다(실제로 그랬다).
	 *    이름표는 **썸네일 밖, 항상 보이게** 둔다.
	 * ⚠️ ✕ 는 썸네일 버튼 **형제**로 얹는다 — 버튼 안의 버튼은 HTML 이 깨지고 클릭이 둘 다 먹는다.
	 * ⚠️ `filled` 는 저장값이 있는지다(URL 이 아직 안 풀렸어도 ✕ 는 보여야 지울 수 있다).
	 */
	import { createEventDispatcher } from "svelte";

	export let label = "";
	/** 썸네일 URL. 비면 `empty` 글자를 보여준다. */
	export let url = "";
	export let filled = false;
	/** 권장 크기·한 줄 설명(예: "390×844"). */
	export let hint = "";
	/** 빈 칸 글자 — 비우면 무엇이 쓰이는지(예: '기본', '런처 배경', '없음'). */
	export let empty = "비어 있음";
	/** square | tall | wide — 그림 비율에 맞춘 썸네일 모양. */
	export let shape = "square";

	const dispatch = createEventDispatcher();
</script>

<div class="slot">
	<!-- ⚠️ 썸네일 자리 높이를 **고정**하고 바닥에 붙인다 — 세로·정사각·가로 칸이 한 줄에 섞여도
	     이름표가 같은 높이에 선다(줄 정렬로 맞추면 설명 줄 수가 다를 때 다시 어긋난다). -->
	<div class="stage">
	<div class="thumb-box">
		<button type="button" class="thumb {shape}" class:is-empty={!url} title={label} on:click={() => dispatch("pick")}>
			{#if url}<img src={url} alt="" />{:else}<span>{empty}</span>{/if}
		</button>
		{#if filled}
			<button type="button" class="clear" aria-label="{label} 비우기" title="{label} 비우기" on:click|stopPropagation={() => dispatch("clear")}>✕</button>
		{/if}
	</div>
	</div>
	<div class="label">{label}</div>
	{#if hint}<div class="hint">{hint}</div>{/if}
</div>

<style>
	.slot {
		display: inline-flex;
		flex-direction: column;
		align-items: center;
		gap: 4px;
		/* 권장 크기 설명("390×844 · 비우면 런처 배경")이 세 줄로 접히지 않을 폭. */
		width: 116px;
	}
	.stage {
		height: 108px;
		display: flex;
		align-items: flex-end;
		justify-content: center;
	}
	/* ⚠️⚠️ 이름을 `.wrap` 으로 두지 말 것 — 빌더 전역(avatalk-builder.webflow.css)에
	   `.wrap { height:100vh; overflow:hidden; background:#f8f8fa }` 가 있다. Svelte 스코프는
	   여기 적은 속성만 이기므로 나머지(높이·잘림·바탕)가 그대로 새어 들어와 칸이 화면 높이로 늘어난다. */
	.thumb-box {
		position: relative;
		display: inline-flex;
	}
	.thumb {
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
		border-radius: 10px;
		border: 1px solid hsl(var(--sb-border));
		background: hsl(var(--sb-muted));
		cursor: pointer;
		padding: 4px;
		transition: border-color 0.15s;
	}
	.thumb:hover {
		border-color: hsl(var(--sb-primary));
	}
	.thumb.is-empty {
		border-style: dashed;
	}
	.thumb.square {
		width: 88px;
		height: 88px;
	}
	.thumb.tall {
		width: 72px;
		height: 108px;
	}
	.thumb.wide {
		width: 96px;
		height: 60px;
	}
	.thumb img {
		max-width: 100%;
		max-height: 100%;
		object-fit: contain;
	}
	.thumb span {
		font-size: 11px;
		color: hsl(var(--sb-muted-foreground));
		text-align: center;
		line-height: 1.3;
	}
	.label {
		font-size: 12px;
		font-weight: 600;
		color: hsl(var(--sb-foreground));
		text-align: center;
		line-height: 1.2;
	}
	.hint {
		font-size: 11px;
		color: hsl(var(--sb-muted-foreground));
		text-align: center;
		line-height: 1.2;
	}
	.clear {
		position: absolute;
		top: -6px;
		right: -6px;
		width: 18px;
		height: 18px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 999px;
		border: 1px solid hsl(var(--sb-border));
		background: hsl(var(--sb-background));
		color: hsl(var(--sb-muted-foreground));
		font-size: 10px;
		line-height: 1;
		padding: 0;
		cursor: pointer;
	}
	.clear:hover {
		color: hsl(var(--sb-destructive));
		border-color: hsl(var(--sb-destructive));
	}
</style>
